module.exports = __webpack_public_path__ + "img/Photo 7- Third Canal 992_17_4.bff4347a.jpg";